/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_C1Inputs */

const en_guide_large_json_files_c1 = /** @type {(inputs: Guide_Large_Json_Files_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What actually breaks first as size grows`)
};

const ko_guide_large_json_files_c1 = /** @type {(inputs: Guide_Large_Json_Files_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기가 커질 때 실제로 먼저 무너지는 것`)
};

const ja_guide_large_json_files_c1 = /** @type {(inputs: Guide_Large_Json_Files_C1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズが大きくなると実際に最初に壊れるもの`)
};

/**
* | output |
* | --- |
* | "What actually breaks first as size grows" |
*
* @param {Guide_Large_Json_Files_C1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_c1 = /** @type {((inputs?: Guide_Large_Json_Files_C1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_C1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_c1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_c1(inputs)
	return ja_guide_large_json_files_c1(inputs)
});